import { useFormatter } from '@api/useFormatter'
import { ProductPill } from '@components/_SiteWide/OrderDisplay/OrderProducts'
import { BBDTag, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import classNames from 'classnames'
import React, { CSSProperties, useMemo, useState } from 'react'

interface ComponentPricesProps {
  data?: Gravitate.Order
  requiresValidPrice?: boolean
}

export function ComponentPrices({ data, requiresValidPrice }: ComponentPricesProps) {
  const { formatCurrency } = useFormatter()
  const formattedPrice = formatCurrency(null, true)
  const showPrice = useMemo(() => {
    const status = data.movement_status === 'delivered' || data.movement_status === 'scheduled'
    if (!status) return requiresValidPrice
    return false
  }, [data, requiresValidPrice])
  const components = data?.component_paths
  const includePrices = data?.include_prices
  const attentionReason = data?.needs_attention_reason
  if (!components || components.length === 0) return null
  components.sort((a, b) => (a.component_product_name > b.component_product_name ? 1 : -1))
  return (
    <Vertical justifyContent='start' className='full-height-width'>
      {components.map((component, i) => (
        <Horizontal key={data.id + component + i} style={{ height: '23px' }}>
          <Vertical flex={1}>
            <div style={{ width: 'fit-content' }}>
              <ProductPill
                multipleProducts={false}
                ratio={{ name: component.component_product_name, volume: component.volume }}
              />
            </div>
          </Vertical>
          {showPrice && (
            <Horizontal flex={1} className='ml-1'>
              {component.price != null ? (
                <Texto>
                  {formattedPrice}
                  {component.price}
                </Texto>
              ) : (
                <Texto appearance='error'>N/A</Texto>
              )}
            </Horizontal>
          )}
        </Horizontal>
      ))}
    </Vertical>
  )
}
